export const SAVE_STYLES_ACTION = "saveStyles";
export const SAVE_DISCOUNT = "saveDiscount";

export const DEFAULT_BACKGROUND_COLOR = "white";
export const DEFAULT_TEXT_FONT = "Montserrat";
export const DEFAULT_BACKGROUND_IMAGE = "";
export const DEFAULT_LOGO = "";
export const DEFAULT_BUTTON_COLOR = "#6a6e37";
export const DEFAULT_BUTTON_TEXT_COLOR = "white";
